import React from 'react';

export default function SubText({ subtext, handleSettingsClick, item, isFormBuilder }) {
  if (!subtext && !isFormBuilder) return null;

  return (
    <span
      className={subtext ? 'help-text-label' : 'cursor-pointer help-text'}
      onClick={!subtext && isFormBuilder ? () => handleSettingsClick(item) : undefined}
    >
      {subtext || (isFormBuilder && '+ Add help text')}
    </span>
  );
}
